
// @ngInject
Filters.UndoSnakeCaseFilter  = function UndoSnakeCaseFilter() {
    return function(s) {
        s = ( s === undefined || s === null ) ? '' : s;
        return s.toString().toLowerCase().replace( /(_)/g, ' ');
    };
};